import {
  getTableauToken,
  getCashBidLocationsWithoutFutures,
  getCashBidLocation,
} from '../../../apis/premier-plus-api';
import {
  userSelectedCashBidLocation,
  showCashBidModal,
} from '../cash-bids/cashBids-actions';
import {handleApiError} from '../../../shared/actions';

export const fetchTableauToken = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'CLEAR_AGRONOMY_TABLEAU_TOKEN',
  });
  dispatch({
    type: 'FETCH_AGRONOMY_TABLEAU_TOKEN_STARTED',
  });
  var response = null;
  const emailAddress = getState().auth.emailAddress;
  try {
    response = await getTableauToken(emailAddress);
  }
  catch (errorCode) {
    dispatch({
      type: 'FETCH_AGRONOMY_TABLEAU_TOKEN_FAILED',
    });
    dispatch(handleApiError(errorCode));
    return;
  }
  dispatch({
    type: 'FETCHED_AGRONOMY_TABLEAU_TOKEN',
    token: response.body,
  });
});

export const showBuyFertilizerModal = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'SHOW_BUY_FERTILIZER_MODAL',
  });
});

export const hideBuyFertilizerModal = () => (async (dispatch, getState) => {
  await dispatch({
    type: 'HIDE_BUY_FERTILIZER_MODAL',
  });
});

export const fetchCashBidLocationsWithoutFutures = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getCashBidLocationsWithoutFutures(false);
  }
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CASH_BID_LOCATIONS_WITHOUT_FUTURES',
    locations: response.body,
  });
});

export const userSelectedCashBidLocationWithoutFutures = (location) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_AGRONOMY_CASH_BID_LOCATION',
    location: location,
  });
});

export const fetchCashBidLocationAndShowModal = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getCashBidLocation(getState().agronomy.selectedLocation.locationId);
  }
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch(userSelectedCashBidLocation(response.body));
  dispatch(showCashBidModal());
});